// Node modules
import { Container, SpineBase, delayedCall, detectDeviceEnvironmentConstants, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import {
  BigWinController,
  SoundConstant,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  MeterBehavior,
} from "@quest/murka-games-behavior-panther/dist";
import { EventConstants as platformEventConstants } from "@quest/platform-murka-phase_2/dist/EventConstants";
import { Model as platformModel } from "@quest/platform-murka-phase_2/dist";

// Game modules
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { Emitter } from "@quest/pixi-bridge/dist/Particles/Emitter";
import { Linear } from "@quest/pixi-bridge/dist/easing/Easing";
import { BigWinViewGame } from "./BigWinViewGame";

export class BigWinControllerGame extends BigWinController {
  private bigWinBackground: SpineBase;
  protected view: BigWinViewGame;
  private bigWinBGContainer: Container;
  private bigWinCharContainer: Container;
  private bigWinBackgroundPortrait: SpineBase;
  private tickupAmountLevel: number;
  private coinShowerContainerMask: any;
  private emitter: Emitter;
  private emitterPortrait: Emitter;
  private bigWinStageClicked: boolean = false;
  private coinShowerStarted = false;
  private bigWinBGContainerPortrait: Container;
  private bigWinCharContainerPortrait: Container;
  private hideBigWinDelay: number = 700;

  /**
   * Overrided to add bigwin spine parts
   */
  public initializeBigWin(): void {
    this.bigWinMeter = this.view.getMeterById("bigWinMtr") as MeterBehavior;
    this.bigWinContainer = this.view.getContainerByID("bigWinContainer");
    this.bigWinMainContainer = this.view.getContainerByID("bigWinMainContainer");
    this.bigWinMeterContainer = this.view.getContainerByID("bigWinMeterContainer");
    this.bgSpineContainer = this.view.getContainerByID("backgroundSpineContainer");
    !ingenuity.deviceEnv.isDesktop && this.initializePortraitComponent();
    this.bigWinBGContainer = this.view.getContainerByID("bigWinBGContainer");
    this.bigWinCharContainer = this.view.getContainerByID("bigWinCharContainer");
    this.bigWinBackground = this.view.createBigWinSpine("Bigwin_spine");
    this.bigWinBGContainer.addChild(this.bigWinBackground);
    this.bgLoopSpine = this.view.createBigWinSpine("Bigwin_spine");
    this.bigWinCharContainer.addChildAt(this.bgLoopSpine, 0);
    this.coinShowerContainerMask = this.view.getShapeById("coinShowerContainerMask") as any;
    if (!ingenuity.deviceEnv.isDesktop) {
      this.coinShowerContainerMask.y = this.view.json.Y_POSITION[1];
    } else {
       if (ingenuity.deviceEnv.getOrientation() !== detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
        this.bigWinMainContainer.mask = this.coinShowerContainerMask;
      }
    }

  }

  // Overrided to initialize portarit elements
  protected initializePortraitComponent(): void {
    this.bigWinBGContainerPortrait = this.view.getContainerByID("bigWinBGContainerPortrait");
    this.bigWinCharContainerPortrait = this.view.getContainerByID("bigWinCharContainerPortrait");
    this.bgLoopPortraitSpine = this.view.createBigWinSpine("Bigwin_spine");
    this.bigWinCharContainerPortrait.addChild(this.bgLoopPortraitSpine);
    this.bigWinBackgroundPortrait = this.view.createBigWinSpine("Bigwin_spine");
    this.bigWinBGContainerPortrait.addChild(this.bigWinBackgroundPortrait);
  }

  // Overrided to hide free spin counter meter & stop base game sound
  protected startBigWin(): void {
    ingenuity.configData.isBasegameBigWin = true;
    ingenuity.configData.showLogoBaseGameScreen = false;
    dispatcher.fireEvent(eventDispatchers.HIDE_TOP_LOGO, this);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BOTTOM_BAR_ON_TOP, this);
    this.bringBigWinBelowButtonPanel();
    this.showBigWinMeterWithZoomIn();
    this.playBgSpineInLoop();
    dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_BIG_WIN_BLUR_BG);
    this.stopBaseGameOrFreeGameSound();
  }

  // function to stop bg and fg sounds
  private stopBaseGameOrFreeGameSound(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_FREESPIN_COUNTER); // GP4:To Hide free game count during bigwin in Free Game
      if ((ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, gameConstants.SOUND_LIST_POSTLOAD)) {
        (ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, gameConstants.SOUND_LIST_POSTLOAD).volume = 0;
      }
    }
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
      if (ingenuity.soundManager.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, "soundList")) {
        ingenuity.soundManager.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, "soundList").volume = 0;
      }
      (ingenuity.soundManager as any).stop(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD);
      (ingenuity.soundManager as any).stop(SoundConstant.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD);
      (ingenuity.soundManager as any).stop(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD);
    }
  }

  // fucnction to start big win feature
  private startBigWinState(): void {
    this.tickupAmountLevel = this.model.getIsBigWin();
    this.currentWinAmountTickUp = this.model.getCurrentWinAmt();
    this.showBigWinState();
  }

  /**
   * function to add button panel on top
   */
  protected playBgSpineInLoop(): void {
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    }
  }

  /**overrided to start big win animation according to tick up level */
  protected showBigWinState(): void {
    if (this.tickupAmountLevel === 1 || this.tickupAmountLevel === 2) {
      this.playDesktopSpine();
      !ingenuity.deviceEnv.isDesktop && this.playPortraitSpine();
    } else if (this.tickupAmountLevel === 3 || this.tickupAmountLevel === 4) {
      this.bigToSuperWin();
    }
  }

  /**overrided to stat tick up meter  according to tick up level*/
  protected showBigWinMeterBasedOnState(): void {
    if (this.tickupAmountLevel === 1) {
      this.bigWinMeter.startTick(
        this.currentWinAmountTickUp,
        true,
        false,
        this.model.getWinMeterTickUpDuration(this.currentWinAmountTickUp),
        true,
        this.bigWinPresentationComplete.bind(this)
      );
    } else if (this.tickupAmountLevel === 2) {
      const tickupAmount = gameConstants.SuperWinMultiplier * this.model.getTotalBet();
      this.bigWinMeter.startTick(
        tickupAmount,
        true,
        false,
        this.model.getWinMeterTickUpDuration(tickupAmount),
        true,
        this.superBigWinState.bind(this)
      );
    } else if (this.tickupAmountLevel === 3 || this.tickupAmountLevel === 4) {
      const tickupAmount = gameConstants.SuperWinMultiplier * this.model.getTotalBet();
      this.bigWinMeter.startTick(
        tickupAmount,
        true,
        false,
        this.model.getWinMeterTickUpDuration(tickupAmount),
        true,
        this.superToEpicWin.bind(this)
      );
    }
  }

  /**
   * Add to start big win tickup
   */
  protected startBigWinTickup(): void {
    this.bigWinMeter.visible = true;
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ENABLE_STAGE_CLICK);
      this.currentWinAmountTickUp = this.model.getCurrentWinAmt();
      //(ingenuity.soundManager as any).playSound(SoundConstant.BIG_WIN_BGM, 1, false, "soundList_1");
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.ENABLE_STAGE_CLICK_FG);
      this.currentWinAmountTickUp = this.model.getCurrentWinAmt();
      //(ingenuity.soundManager as any).playSound(SoundConstant.FG_BIG_WIN_BGM, 1, false, "soundList_1");
    }
  }

  // function to start coin shower in super big win and sum up count till super win
  private superBigWinState(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_SUPER_WIN_BLUR_BG);
    this.bigWinMeter.startTick(
      this.currentWinAmountTickUp,
      true,
      false,
      this.model.getWinMeterTickUpDuration(this.currentWinAmountTickUp),
      true,
      this.bigWinPresentationComplete.bind(this)
    );
    this.playSuperWinSpine();
    this.playSuperWinForPort();
  }

  // function to play spine of super win
  private playSuperWinSpine(): void {
    this.bigWinBackground.playAnim("Big_win_to_super_win_convert_desktop_bg", false);
    this.bgLoopSpine.playAnim("Big_win_to_super_win_convert_desktop_fg", false);
    this.bgLoopSpine.onComplete.addOnce(() => {
      this.bgLoopSpine.playAnim("super_win_loop_desktop_fg", true);
      this.bigWinBackground.playAnim("super_win_loop_desktop_bg", true);
    });
  }

  // function to play spine of super win portrait
  private playSuperWinSpinePortrait(): void {
    this.bgLoopPortraitSpine.playAnim("Big_win_to_super_win_convert_portrait_fg", false);
    this.bigWinBackgroundPortrait.playAnim("Big_win_to_super_win_convert_portrait_bg", false);
    this.bgLoopPortraitSpine.onComplete.addOnce(() => {
      this.bgLoopPortraitSpine.playAnim("super_win_loop_portrait_fg", true);
      this.bigWinBackgroundPortrait.playAnim("super_win_loop_portrait_bg", true);
    });
  }

  // function to call playEpicWinSpine function and tickup to the current win
  private epicBigWinState(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_EPIC_WIN_BLUR_BG);
    this.bigWinMeter.startTick(
      this.currentWinAmountTickUp,
      true,
      false,
      this.model.getWinMeterTickUpDuration(this.currentWinAmountTickUp),
      true,
      this.bigWinPresentationComplete.bind(this)
    );
    this.playEpicWinSpine();
    !ingenuity.deviceEnv.isDesktop && this.playEpicWinSpinePortrait();
  }
  // function to play spine of epic win
  private playEpicWinSpine(): void {
    this.bgLoopSpine.playAnim("super_win_to_epic_win_convert_desktop_fg", false);
    this.bigWinBackground.playAnim("super_win_to_epic_win_convert_desktop_bg", false);
    this.bgLoopSpine.onComplete.addOnce(() => {
      this.bgLoopSpine.playAnim("epic_win_loop_desktop_fg", true);
      this.bigWinBackground.playAnim("epic_win_loop_desktop_bg", true);
    }, this);
  }

  // function to play spine of epic win portrait
  private playEpicWinSpinePortrait(): void {
    this.bgLoopPortraitSpine.playAnim("super_win_to_epic_win_convert_portrait_fg", false);
    this.bigWinBackgroundPortrait.playAnim("super_win_to_epic_win_convert_portrait_bg", false);
    this.bigWinBackgroundPortrait.onComplete.addOnce(() => {
      this.bgLoopPortraitSpine.playAnim("epic_win_loop_portrait_fg", true);
      this.bigWinBackgroundPortrait.playAnim("epic_win_loop_portrait_bg", true);
    }, this);
  }
  // function to handle crazy big win state
  private crazyBigWinState(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_CRAZY_WIN_BLUR_BG);
    this.bigWinMeter.startTick(
      this.currentWinAmountTickUp,
      true,
      false,
      this.model.getWinMeterTickUpDuration(this.currentWinAmountTickUp),
      true,
      this.bigWinPresentationComplete.bind(this)
    );
    this.playCrazyWinSpine();
    !ingenuity.deviceEnv.isDesktop && this.playCrazyWinSpinePortrait();
  }
  // function to play spine of crazy win
  private playCrazyWinSpine(): void {
    this.bgLoopSpine.playAnim("epic_win_to_crazy_win_convert_desktop_fg", false);
    this.bigWinBackground.playAnim("epic_win_to_crazy_win_convert_desktop_bg", false);
    this.bgLoopSpine.onComplete.addOnce(() => {
      this.bgLoopSpine.playAnim("crazy_win_loop_desktop_fg", true);
      this.bigWinBackground.playAnim("crazy_win_loop_desktop_bg", true);
    }, this);
  }

  // function to play spine of crazy win
  private playCrazyWinSpinePortrait(): void {
    this.bgLoopPortraitSpine.playAnim("epic_win_to_crazy_win_convert_portrait_fg", false);
    this.bigWinBackgroundPortrait.playAnim("epic_win_to_crazy_win_convert_portrait_bg", false);
    this.bgLoopSpine.onComplete.addOnce(() => {
      this.bgLoopPortraitSpine.playAnim("crazy_win_loop_portrait_fg", true);
      this.bigWinBackgroundPortrait.playAnim("crazy_win_loop_portrait_bg", true);
    }, this);
  }

  // fucntion to big win spine if super win is also triggered
  private bigToSuperWin(): void {
    this.playDesktopSpine();
    !ingenuity.deviceEnv.isDesktop && this.playPortraitSpine();
    this.bgLoopSpine.visible = true;
    this.bigWinBackground.visible = true;
  }
  // function to sum up epic win if tick up amount is 3 or if tick up is 4 then function is called for crazy win
  private superToEpicWin(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_SUPER_WIN_BLUR_BG);
    const tickupAmount = gameConstants.EpicWinMultiplier * this.model.getTotalBet() - 1;
    if (this.tickupAmountLevel === 4) {
      this.bigWinMeter.startTick(
        tickupAmount,
        true,
        false,
        this.model.getWinMeterTickUpDuration(tickupAmount),
        true,
        this.epictoCrazyWin.bind(this)
      );
      this.playSuperWinSpine();
      this.playSuperWinForPort();
    } else {
      this.bigWinMeter.startTick(
        tickupAmount,
        true,
        false,
        this.model.getWinMeterTickUpDuration(tickupAmount),
        true,
        this.epicBigWinState.bind(this)
      );
      this.playSuperWinSpine();
      this.playSuperWinForPort();
    }
  }

  private playSuperWinForPort(): void {
    !ingenuity.deviceEnv.isDesktop && this.playSuperWinSpinePortrait();
  }

  // function to sum up tick up meter tll epic win
  private epictoCrazyWin(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_EPIC_WIN_BLUR_BG);
    const tickupAmount = gameConstants.CrazyWinMultiplier * this.model.getTotalBet() - 1;
    this.bigWinMeter.startTick(
      tickupAmount,
      true,
      false,
      this.model.getWinMeterTickUpDuration(tickupAmount),
      true,
      this.crazyBigWinState.bind(this)
    );
    this.playEpicWinSpine();
    !ingenuity.deviceEnv.isDesktop && this.playEpicWinSpinePortrait();
  }

  /**
   * Overrided to play bigwin spine in parts
   */
  protected playDesktopSpine(): void {
    (ingenuity.soundManager as any).playSound(SoundConstant.BIG_WIN_START, 1, false, "soundList_1");
    this.bgLoopSpine.setPause(false);
    this.bgLoopSpine.visible = true;
    this.bigWinBackground.setPause(false);
    this.bigWinBackground.visible = true;
    this.playCoinShower();
    this.bgLoopSpine.playAnim("Big_win_in_desktop_fg", false);
    this.bigWinBackground.playAnim("Big_win_in_desktop_bg", false);
    this.bgLoopSpine.onComplete.addOnce(() => {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
        id: SoundConstant.BIG_WIN_LOOP,
        vol: 1,
        loop: true,
        key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD,
      });
      this.bgLoopSpine.playAnim("Big_win_loop_desktop_fg", true);
      this.bigWinBackground.playAnim("Big_win_loop_desktop_bg", true);
    }, this);
  }

  // Overrided to play portrait spine
  protected playPortraitSpine(): void {
    this.bigWinBackgroundPortrait.visible = true;
    this.bigWinBackgroundPortrait.playAnim("Big_win_in_portrait_bg", false);
    this.bgLoopPortraitSpine.visible = true;
    this.bgLoopPortraitSpine.playAnim("Big_win_in_portrait_fg", false);
    this.bigWinBackgroundPortrait.onComplete.addOnce(() => {
      this.bigWinBackgroundPortrait.playAnim("Big_win_loop_portrait_bg", true);
      this.bgLoopPortraitSpine.playAnim("Big_win_loop_portrait_fg", true);
    }, this);
  }

  // Overrided to stop big win bgm sound
  protected bigWinPresentationComplete() {
    ingenuity.soundManager.stop(SoundConstant.BIG_WIN_LOOP, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    (ingenuity.soundManager as any).playSound(SoundConstantGame.BIG_WIN_END_SOUND, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);
    delayedCall(
      SlotConstantsBehavior.FADE_OUT_BIG_WIN_DELAY,
      this.hideBigWinDelay,
      () => {
        killDelayedCall(SlotConstantsBehavior.FADE_OUT_BIG_WIN_DELAY);
        this.hideBigWin();
        dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
        dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_WIN_METER_BEFORE_CLOSE_IN_BIGWIN, { value: this.currentWinAmountTickUp });
        dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_FREE_GAME_WIN_METER_AFTER_BIGWIN, this.currentWinAmountTickUp);
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
          //   dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_BOTTOM_BAR_WIN, {
          //     value: (ingenuity.parserModel as GameParserModel).getGameWinAmt(),
          //   });
          dispatcher.fireEvent(platformEventConstants.UPDATE_BS_WIN, { value: (ingenuity.parserModel as GameParserModel).getGameWinAmt() });
        }
      },
      this
    );
  }

  // Overridden method to handle big win hiding with animations
  protected hideBigWin() {
    const { winType, blurBgType } = this.getWinDetails();
    if (this.bigWinStageClicked) {
      this.initCoinEmitter(blurBgType);
      this.animateWinOut(winType);
      !ingenuity.deviceEnv.isDesktop && this.animateWinOutPortrait(winType);
    } else {
      this.hideBigWinter();
      this.bgLoopSpine.playAnim(`${winType}_out_desktop_fg`, false);
      this.bigWinBackground.playAnim(`${winType}_out_desktop_bg`, false);
      if (!ingenuity.deviceEnv.isDesktop) {
        this.bgLoopPortraitSpine.playAnim(`${winType}_out_portrait_fg`, false);
        this.bigWinBackgroundPortrait.playAnim(`${winType}_out_portrait_bg`, false);
      }
    }
    this.bigWinBackground.onComplete.addOnce(() => {
      this.hideBigWinWithFadeOutEffect();
      this.hideBigWinBasedOnState();
      this.bigWinStageClicked = false;
      ingenuity.configData.enableStageClick = false;
      dispatcher.fireEvent(SlotEventConstantsBehavior.DISABLE_STAGE_CLICK);
      this.stopCoinShower();
      ingenuity.configData.showLogoBaseGameScreen = true;
      ingenuity.configData.isBasegameBigWin = false;
      dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO, this);
    }, this);
  }

  // fucntion to init coins shower and pass blur bg type as argument
  private initCoinEmitter(blurBgType: string): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, blurBgType);
    if (!this.coinShowerStarted && this.tickupAmountLevel > 0) {
      this.playCoinShower();
    }
  }

  // Add to play coin shower
  private playCoinShower(): void {
    this.initializeCoinShowerEmitter();
    this.startCoinShowerEmitter();
    if (!ingenuity.deviceEnv.isDesktop) {
      this.initPortraitCoinShowerEmitter();
      this.startPortraitShowerEmitter();
    }
  }

  // Abstract method for handling win animations of portrait
  private animateWinOutPortrait(winType: string): void {
    this.bgLoopPortraitSpine.onComplete.dispose();
    this.bigWinBackgroundPortrait.onComplete.dispose();
    this.bgLoopPortraitSpine.playAnim(`${winType}_loop_portrait_fg`, false);
    this.bigWinBackgroundPortrait.playAnim(`${winType}_loop_portrait_bg`, false);
    this.bgLoopPortraitSpine.onComplete.addOnce(() => {
      this.hideBigWinter();
      this.bgLoopPortraitSpine.playAnim(`${winType}_out_portrait_fg`, false);
      this.bigWinBackgroundPortrait.playAnim(`${winType}_out_portrait_bg`, false);
    }, this);
  }

  // Abstract method for handling win animations
  private animateWinOut(winType: string): void {
    this.bgLoopSpine.onComplete.dispose();
    this.bigWinBackground.onComplete.dispose();
    this.bgLoopSpine.playAnim(`${winType}_loop_desktop_fg`, false);
    this.bigWinBackground.playAnim(`${winType}_loop_desktop_bg`, false);
    this.bgLoopSpine.onComplete.addOnce(() => {
      this.hideBigWinter();
      this.bgLoopSpine.playAnim(`${winType}_out_desktop_fg`, false);
      this.bigWinBackground.playAnim(`${winType}_out_desktop_bg`, false);
    }, this);
  }

  // Abstract method to get win details based on tickupAmountLevel
  private getWinDetails(): { winType: string; blurBgType: string } {
    switch (this.tickupAmountLevel) {
      case 1:
        return { winType: "Big_win", blurBgType: gameConstants.SHOW_BIG_WIN_BLUR_BG };
      case 2:
        return { winType: "super_win", blurBgType: gameConstants.SHOW_SUPER_WIN_BLUR_BG };
      case 3:
        return { winType: "epic_win", blurBgType: gameConstants.SHOW_EPIC_WIN_BLUR_BG };
      case 4:
        return { winType: "crazy_win", blurBgType: gameConstants.SHOW_CRAZY_WIN_BLUR_BG };
      default:
        throw new Error(`Unsupported tickupAmountLevel: ${this.tickupAmountLevel}`);
    }
  }

  // Override to unfade 2nd free game bgm
  protected hideBigWinBasedOnState(): void {
    dispatcher.fireEvent(eventDispatchers.HIDE_POP_UP_BLUR_BG);
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.MUSIC_SPIN, 0.8, false, gameConstants.SOUND_LIST_PRELOAD);
      this.model.setIsBigWinRunning(false);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_AFTER_BIGWIN);
      // This method will send game close if there is no feature triggered after bigwin
      if (
        !(ingenuity.parserModel as GameParserModel).getHoldAndRespinStatus() &&
        !(ingenuity.parserModel as platformModel).getFreeSpinsRemaining()
      ) {
        dispatcher.fireEvent(SlotEventConstantsBehavior.SEND_CLOSE_GAME_REQUEST);
      }
      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
    } else {
      if ((ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, gameConstants.SOUND_LIST_POSTLOAD)) {
        (ingenuity.soundManager as any).getSoundInstance(SoundConstant.FREGAME_BGLOOP, gameConstants.SOUND_LIST_POSTLOAD).volume = 1;
      }
      ingenuity.currentGame.state.getCurrentState().model.setIsBigWinRunning(false);
      dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_FREE_GAME_AFTER_BIGWIN);
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOTAL_WIN_MSG);
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_FREESPIN_COUNTER);
    }
  }

  /**
   * Initialize Data for Coin Shower Emmiter
   */
  private initializeCoinShowerEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinEmitter",
      autoStart: false,
      animConfig: [
        {
          framerate: 20,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 0.8,
        end: 1,
        minimumScaleMultiplier: 0.5,
      },
      speed: {
        start: 500,
        end: 500,
        minimumSpeedMultiplier: 2,
      },
      acceleration: {
        x: 0,
        y: 200,
      },
      maxSpeed: 0,
      startRotation: {
        min: -140,
        max: -50,
      },
      noRotation: true,
      rotationSpeed: {
        min: 0,
        max: 0,
      },
      lifetime: {
        min: 3,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.05,
      emitterLifetime: -1,
      maxParticles: 150,
      pos: {
        x: 0,
        y: 0,
      },
      addAtBack: false,
      spawnType: "point",
    };
    const coinShowerContainer: Container = this.view.getContainerByID("coinShowerContainer");
    coinShowerContainer && (coinShowerContainer.mask = this.coinShowerContainerMask);
    ingenuity.currentGame.add.emitter(coinShowerContainer, particleData, config) as Emitter;
  }

  // Add to initialize portrait coin shower emitter
  private initPortraitCoinShowerEmitter(): void {
    const particleData1: any = {
      emitterType: 1,
      id: "winCoinEmitterPortrait",
      autoStart: false,
      animConfig: [
        {
          framerate: 20,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config1 = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 0.9,
        end: 1,
        minimumScaleMultiplier: 0.5,
      },
      speed: {
        start: 500,
        end: 500,
        minimumSpeedMultiplier: 2,
      },
      acceleration: {
        x: 0,
        y: 160,
      },
      maxSpeed: 0,
      startRotation: {
        min: -140,
        max: -50,
      },
      noRotation: true,
      rotationSpeed: {
        min: 0,
        max: 0,
      },
      lifetime: {
        min: 3,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.05,
      emitterLifetime: -1,
      maxParticles: 150,
      pos: {
        x: 0,
        y: 0,
      },
      addAtBack: false,
      spawnType: "point",
    };
    const coinShowerContainer: Container = this.view.getContainerByID("coinShowerPortraitContainer");
    ingenuity.currentGame.add.emitter(coinShowerContainer, particleData1, config1) as Emitter;
  }

  /**
   * Method to start the emitter
   * @returns
   */
  private startCoinShowerEmitter(): void {
    this.coinShowerStarted = true;
    this.emitter = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter");
    this.emitter.autoUpdate = true;
    this.emitter.emit = true;
  }

  /**
   * Method to start the emitter
   * @returns
   */
  private startPortraitShowerEmitter(): void {
    this.emitterPortrait = ingenuity.currentGame.particles.getEmitterById("winCoinEmitterPortrait");
    this.emitterPortrait.autoUpdate = true;
    this.emitterPortrait.emit = true;
  }

  // function to stop big win tickup on stage click
  protected stopBigWinAndTicker(): void {
    this.bigWinStageClicked = true;
    this.hideBigWinDelay = 100;
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      this.bigWinPresentationComplete();
      this.bigWinMeter.stopTick(false, true, true);
      this.bigWinMeter.stopTick(false, true, true);
      this.bigWinMeter.stopTick(false, true, true);
      this.bigWinMeter.stopTick(false, true, true);
      this.bigWinMeter.stopTick(false, true, true);
      this.bigWinMeter.setCurrencyFormattedValue(String(this.currentWinAmountTickUp));
    } else {
      dispatcher.fireEvent(eventDispatchers.HIDE_FREEGAME_BIG_WIN);
    }
  }

  /**
   * Add to show big win meter with zoom in effect
   */
  protected showBigWinMeterWithZoomIn(): void {
    this.bigWinMeterContainer.scale.set(0, 0);
    this.bigWinMeter.visible = false;
    this.bigWinMeter.setValue(0);
    this.startBigWinState();
    const bigWinMeterZoomInTween = ingenuity.currentGame.add
      .tween(this.bigWinMeterContainer.scale)
      .to({ x: 1, y: 1 }, 400, Linear.None, true, 0, 0, false);
    bigWinMeterZoomInTween.onComplete.addOnce(() => {
      delayedCall("startTickup", 100, () => {
        killDelayedCall("startTickup");
        this.bigWinMeterContainer.visible = true;
        this.bigWinMeterContainer.alpha = 1;
        this.startBigWinTickup();
      });
      bigWinMeterZoomInTween.stop();
      ingenuity.currentGame.tweens.remove(bigWinMeterZoomInTween);
      this.showBigWinMeterBasedOnState();
      this.startBigWinBasedOnState();
    }, this);
  }

  /**
   * stop coin shower on big win hide
  */
  private stopCoinShower(){
    if (this.emitter) {
      this.emitter.emit = false;
      this.emitter.autoUpdate = false;
      this.emitter.destroy();
    }
    if (this.emitterPortrait) {
      this.emitterPortrait.emit = false;
      this.emitterPortrait.autoUpdate = false;
      this.emitterPortrait.destroy();
    }
    this.coinShowerStarted = false;
  }

  /**
   * hide win mtr with out animation 
   */
  private hideBigWinter():void{
    delayedCall('hideBigWinMtr',170,()=>{
      killDelayedCall('hideBigWinMtr');
      this.bigWinMeterContainer.visible = false;
    })
  }

  /** overrrided to reset big spine */
  protected resetElements(): void {
    this.hideBigWinDelay = 700;
    this.bigWinMeter.setValue(0);
    this.bigWinMeterContainer.scale.set(1, 1);
    this.bigWinMainContainer.alpha = 1;
    this.bgLoopSpine.visible = false;
    this.bgLoopSpine.setPause(true);
    this.bgLoopSpine.onComplete.dispose();
    this.bigWinBackground.visible = false;
    this.bigWinBackground.setPause(true);
    this.bigWinBackground.onComplete.dispose();
    if (!ingenuity.deviceEnv.isDesktop) {
      this.bgLoopPortraitSpine.visible = false;
      this.bigWinBackgroundPortrait.visible = false;
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_FREESPIN_COUNTER);
  }
}
